<template>
    <div id="about">
        <!-- banner -->
        <img class="banner" src="../assets/images/about/banner.png" alt>

        <div class="type_area about">
        <!-- title -->
        <div class="title">
            <span>COMPANY</span>
            <!-- <span class="color">US</span> -->
        </div>

        <!-- 内容 -->
        <div class="content" v-html="about.body"></div>

        <!-- 图片 -->
<!--        <div class="video">-->
<!--            <video-player-->
<!--                class="video-player vjs-custom-skin"-->
<!--                ref="videoPlayer"-->
<!--                :playsinline="true"-->
<!--                :options="playerOptions"-->
<!--                >-->
<!--            </video-player>-->
<!--        </div>-->
        </div>
    </div>
</template>



<script>
import { constants } from "crypto";
export default {
    data: function() {
        return {
            about: [],
            playerOptions: {
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: "zh-CN",
                aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                    {
                        src: "//path/to/video.mp4", // 路径
                        type: "video/mp4" // 类型
                    },
                    {
                        src: "//path/to/video.webm",
                        type: "video/webm"
                    }
                ],
                poster: "../../static/images/test.jpg", //封面图片
                notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: true,
                    durationDisplay: true,
                    remainingTimeDisplay: false,
                    fullscreenToggle: true //全屏按钮
                }
            }
        };
    },

    mounted() {
        this.$http
        .get("/api/about.php")
        .then(res => {
            this.about = res.data.data[0];
            this.playerOptions.sources[0].src = res.data.data[0].video;
            this.playerOptions.poster = res.data.data[0].litpic;
        });
    }
};
</script>



<style scoped lang="less">
#about {
    margin: 3rem 0 0;
    min-height: 45.5rem;
    .banner {
        width: 100%;
    }
    // 关于我们内容盒子
    .about {
        border: 1px solid transparent;
    }

    // title
    .title {
        margin: 1rem 0;
        text-align: center;
        font-weight: bold;
        .color {
        color: #257ce1;
        margin-left: 1rem;
        }
    }

    // content
    .content {
        width: 100%;
        // height:24rem;
        line-height: 2rem;
    }

    // img
    .video {
        margin: 2rem 0;
    }
    
}

</style>
